import { RobotoCallSliceType } from '@reducers/roboto-call-slice';
import { isEmptyArr } from '@utils/index';

import { automationTypeValues, queryValuesWithFields } from './constants/call-collection';
import { CollectionQueryValueType } from './models/call-collection';

export const isValidQueries = (queries: RobotoCallSliceType['audience']['queries']) =>
  queries?.every(({ check, field, ...arg }) => {
    if (check && field) {
      let key: 'value' | 'ids' | 'subIds' | 'date' = 'value';
      let type: CollectionQueryValueType = 'input';

      const queryTypeKeys = {
        input: 'value',
        datepicker: 'date',
        multiSelect: 'ids'
      } as const;

      Object.keys(queryValuesWithFields).forEach(key => {
        if (queryValuesWithFields[key as keyof typeof queryValuesWithFields]?.some(value => value === field)) {
          type = key as keyof typeof queryValuesWithFields;
        }
      });

      key = queryTypeKeys[type];

      // @ts-expect-error
      return type === 'multiSelect' ? !isEmptyArr(arg?.ids || []) || !isEmptyArr(arg?.subIds || []) : arg?.[key];
    }

    return false;
  });

export const isValidPlanning = (planning: RobotoCallSliceType['planning']) =>
  Boolean(
    planning.channel &&
      planning.retryCount &&
      planning.channelsParallelCallCount &&
      planning.automationType &&
      (planning.automationType !== 'NOW' ? planning.startTime : true) &&
      (planning.automationType as unknown) !== 'OTHER' &&
      ([
        'OTHER',
        automationTypeValues.EVERY_DAY,
        automationTypeValues.CUSTOM_DAILY,
        automationTypeValues.CUSTOM_WEEKLY
      ].includes(planning.automationType || '')
        ? planning.startDate
        : true) &&
      (planning.automationType === 'SCHEDULE' ? planning.scheduleDate : true) &&
      (planning.automationType === 'CUSTOM_DAILY' ? planning.repeatEveryDay : true) &&
      (planning.automationType === 'CUSTOM_WEEKLY' ? !isEmptyArr(planning.dayOfWeeks) : true)
  );

export const isValidAudience = (audience: RobotoCallSliceType['audience']) =>
  Boolean(audience.dataType && audience.name && isValidQueries(audience.queries));
